export enum PortfolioPageViews {
  Positions = 'positions',
  Performance = 'performance',
  Orders = 'orders',
}
